export default __webpack_public_path__ + "static/media/gallery_02.eb9d275a.jpg";